export default "__VITE_ASSET__6545cb1c__"